import { toast } from './toast';
import patch from './patch';
import Logger from '../../Logger';

export const handleUnexpectedError = err => (dispatch, getState) => {
  dispatch(patch({ ui: { spinner: false } }));
  Logger.error(err);
  toast(dispatch, getState({
    style: 'danger',
    message: 'Sorry, we\'ve experienced an unexpected error. We\'re looking into it. In the meantime, feel free to contact {}.',
  }, 10000));
};
